import { htmlEncode } from '../utilities';

export function bindPrintables() {
    // look for [data-print] attribute.
    // [data-target] sets the id of the element to print.
    // If data-target is not set, print the innerHTML of the element with the data-print attribute.
    document.querySelectorAll<HTMLElement>("[data-print]").forEach(toggle => {
        toggle.addEventListener("click", evt => {
            evt.preventDefault();
            printClick(toggle);
        });
    });
}

function printClick(elem: HTMLElement) {
    if ("printPage" in elem.dataset) {
        window.print();
        return;
    }
    const printFrameName: string = 'printFrame';
    const printTargetID: string | null = elem.getAttribute('data-target');
    const printTitle: string = elem.getAttribute('data-title') || '';
    const printTargetContents: string | undefined = (printTargetID === null) ? elem.innerHTML : document.querySelector(`#${printTargetID}`)?.innerHTML;
    if (printTargetContents === undefined) {
        console.debug('Nothing to print. Print target contents are undefined.');
        return;
    }
    const printFrame: HTMLIFrameElement = document.createElement('iframe');
    const printStyles = '<style>.no-print{display: none;}</style>';
    const printContents = `<html><head><title>${htmlEncode(printTitle)}</title>${printStyles}</head><body>${printTargetContents}</body></html>`;

    printFrame.name = printFrameName;
    printFrame.className = 'hidden';
    document.querySelector('body')?.append(printFrame);

    const frameDoc: Document | null = printFrame.contentWindow?.document || printFrame.contentDocument;

    if (frameDoc === null) {
        console.debug('Could not create the print frame document.');
        return;
    }
    frameDoc.open();
    frameDoc.write(printContents);
    frameDoc.close();

    setTimeout(() => {
        printFrame.focus();
        printFrame.contentWindow?.print();

        printFrame.remove();
    }, 500)
}

document.addEventListener('DOMContentLoaded', (event) => {
    bindPrintables();
});
